import { render, staticRenderFns } from "./BudgetForm.vue?vue&type=template&id=9d6e5242&scoped=true&"
import script from "./BudgetForm.vue?vue&type=script&lang=js&"
export * from "./BudgetForm.vue?vue&type=script&lang=js&"
import style0 from "./BudgetForm.vue?vue&type=style&index=0&id=9d6e5242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6e5242",
  null
  
)

export default component.exports